// extracted by mini-css-extract-plugin
export default {"confirm":"CancelSubscription_confirm__3XvXP","notes":"CancelSubscription_notes__E6NoO"};